<template>
  <div :class="['panel', panelClass, 'glass-form-panel', small ? 'glass-form-panel-small' : '']">
    <div class="panel-heading">{{title}}</div>
    <div class="panel-body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.glass-form-panel > .panel-heading {
  font-weight: bold;
}
.panel-default > .panel-heading {
  color: inherit;
}
.glass-form-panel-small {
  font-size: 0.7rem;
}
</style>

<script>
export default {
  name: 'FormPanel',
  props: {
    title: String,
    panelClass: {
      type: String,
      default: 'panel-default'
    },
    small: Boolean
  }
}
</script>